import { clsx } from 'clsx'
import { type FC } from 'react'

import {
  SOCIAL_MEDIA_NAMES,
  SocialMediaImage,
} from '../../../../../../social-media'
import { useProductPageContext } from '../../../../productPageContext'

export const ProductBuyBoxSocialPopupModalIcons: FC = () => {
  const { socialMediaConfig } = useProductPageContext()

  return (
    <ul className="flex justify-between gap-3">
      {socialMediaConfig.map((socialMediaElement) => {
        return (
          <li
            className={clsx(
              socialMediaElement.name === SOCIAL_MEDIA_NAMES.WHATSAPP &&
                'tablet:hidden',
            )}
            key={socialMediaElement.name}
          >
            <a href={socialMediaElement.url} rel="noreferrer" target="_blank">
              <SocialMediaImage iconName={socialMediaElement.name} />
            </a>
          </li>
        )
      })}
    </ul>
  )
}
